import api from './api';
import { Vendor, VendorFormData, VendorListItem } from '@/types/vendor';

export const vendorApi = {
    // Tüm vendor'ları listele (admin)
    async getAllVendors(params?: {
        status?: string;
        approvalStatus?: string;
        limit?: number;
        offset?: number;
    }): Promise<{ vendors: VendorListItem[]; total: number }> {
        try {
            console.log('📡 Calling GET /admin/vendors with params:', params);
            const response = await api.get('/admin/vendors', { params });
            console.log('📥 Response:', response.data);
            return response.data;
        } catch (error: any) {
            console.error('❌ Vendor API Error:', error.response || error);
            throw new Error(error.response?.data?.error || 'Vendor listesi yüklenemedi');
        }
    },

    // Vendor detayı getir
    async getVendor(vendorId: string): Promise<Vendor> {
        try {
            const response = await api.get(`/admin/vendors/${vendorId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching vendor:', error);
            throw new Error(error.response?.data?.error || 'Vendor yüklenemedi');
        }
    },

    // Yeni vendor oluştur (admin)
    async createVendor(vendorData: VendorFormData): Promise<Vendor & { passwordResetLink?: string }> {
        try {
            const response = await api.post('/admin/vendors', vendorData);
            return response.data;
        } catch (error: any) {
            console.error('Error creating vendor:', error);
            const errorMessage = error.response?.data?.details || error.response?.data?.error || 'Vendor oluşturulamadı';
            throw new Error(errorMessage);
        }
    },

    // Vendor güncelle (admin)
    async updateVendor(vendorId: string, vendorData: Partial<VendorFormData>): Promise<Vendor> {
        try {
            const response = await api.put(`/admin/vendors/${vendorId}`, vendorData);
            return response.data;
        } catch (error: any) {
            console.error('Error updating vendor:', error);
            throw new Error(error.response?.data?.error || 'Vendor güncellenemedi');
        }
    },

    // Vendor durumu değiştir
    async updateVendorStatus(vendorId: string, status: string): Promise<{ success: boolean }> {
        try {
            const response = await api.put(`/admin/vendors/${vendorId}/status`, { status });
            return response.data;
        } catch (error: any) {
            console.error('Error updating vendor status:', error);
            throw new Error(error.response?.data?.error || 'Durum güncellenemedi');
        }
    },

    // Vendor sil (admin)
    async deleteVendor(vendorId: string): Promise<{ success: boolean }> {
        try {
            const response = await api.delete(`/admin/vendors/${vendorId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error deleting vendor:', error);
            throw new Error(error.response?.data?.error || 'Vendor silinemedi');
        }
    },

    // Vendor onayla (admin)
    async approveVendor(vendorId: string, approvedBy?: string): Promise<Vendor> {
        try {
            const response = await api.put(`/admin/vendors/${vendorId}`, {
                approvalStatus: 'approved',
                approvedBy
            });
            return response.data;
        } catch (error: any) {
            console.error('Error approving vendor:', error);
            throw new Error(error.response?.data?.error || 'Vendor onaylanamadı');
        }
    },

    // Vendor reddet (admin)
    async rejectVendor(vendorId: string, rejectionReason: string): Promise<Vendor> {
        try {
            const response = await api.put(`/admin/vendors/${vendorId}`, {
                approvalStatus: 'rejected',
                rejectionReason
            });
            return response.data;
        } catch (error: any) {
            console.error('Error rejecting vendor:', error);
            throw new Error(error.response?.data?.error || 'Vendor reddedilemedi');
        }
    },
};
